import React, { useEffect, useState, useRef } from 'react';
export function BeforeAfter() {
  return <section id="gallery" className="py-24 bg-surface border-y border-accent/10" data-id="element-12">
      <div className="container mx-auto px-4" data-id="element-13">
        <div className="text-center mb-16" data-id="element-14">
          <h2 className="font-display text-4xl md:text-5xl text-white uppercase tracking-wide mb-4" data-id="element-15">
            See the <span className="text-accent" data-id="element-16">Difference</span>
          </h2>
          <p className="text-slate-400 max-w-2xl mx-auto text-lg" data-id="element-17">
            Drag the slider to reveal the dramatic results of our professional
            cleaning services.
          </p>
        </div>

        <div className="max-w-5xl mx-auto flex flex-col gap-12" data-id="element-18">
          <ComparisonSlider beforeImage="https://cdn.magicpatterns.com/uploads/8RD6ei2QQpYf2DqhzWifuK/rinsekings-before1.jpg" afterImage="https://cdn.magicpatterns.com/uploads/rrwQ8npuh1cvmAZhnYuFS9/rinsekings-after1.jpg" label="Paver Driveway Restoration" data-id="element-19" />
          <ComparisonSlider beforeImage="https://cdn.magicpatterns.com/uploads/5H9sh4cNCcsh24gk5bmGjm/rinsekings-before2.jpg" afterImage="https://cdn.magicpatterns.com/uploads/vuA78ub2art8B7fhzRxXMk/rinsekings-after2.jpg" label="Pool Deck Restoration" data-id="element-20" />
        </div>
      </div>
    </section>;
}
function ComparisonSlider({
  beforeImage,
  afterImage,
  label
}: {
  beforeImage: string;
  afterImage: string;
  label: string;
}) {
  const [sliderPosition, setSliderPosition] = useState(50);
  const [isDragging, setIsDragging] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);
  const handleMove = (clientX: number) => {
    if (!containerRef.current) return;
    const rect = containerRef.current.getBoundingClientRect();
    const x = Math.max(0, Math.min(clientX - rect.left, rect.width));
    const percent = Math.max(0, Math.min(x / rect.width * 100, 100));
    setSliderPosition(percent);
  };
  useEffect(() => {
    const onMouseMove = (e: MouseEvent) => {
      if (!isDragging) return;
      handleMove(e.clientX);
    };
    const onTouchMove = (e: TouchEvent) => {
      if (!isDragging) return;
      handleMove(e.touches[0].clientX);
    };
    const onUp = () => setIsDragging(false);
    if (isDragging) {
      window.addEventListener('mousemove', onMouseMove);
      window.addEventListener('mouseup', onUp);
      window.addEventListener('touchmove', onTouchMove);
      window.addEventListener('touchend', onUp);
    }
    return () => {
      window.removeEventListener('mousemove', onMouseMove);
      window.removeEventListener('mouseup', onUp);
      window.removeEventListener('touchmove', onTouchMove);
      window.removeEventListener('touchend', onUp);
    };
  }, [isDragging]);
  return <div className="flex flex-col gap-4" data-id="element-21">
      <h3 className="text-xl font-bold text-white text-center" data-id="element-22">{label}</h3>
      <div ref={containerRef} className="relative w-full aspect-[4/3] md:aspect-[16/9] rounded-xl overflow-hidden cursor-ew-resize select-none border-2 border-accent/30 shadow-2xl" onMouseDown={e => {
      setIsDragging(true);
      handleMove(e.clientX);
    }} onTouchStart={e => {
      setIsDragging(true);
      handleMove(e.touches[0].clientX);
    }} data-id="element-23">
        <div className="absolute inset-0 bg-cover bg-center" style={{
        backgroundImage: `url(${afterImage})`,
        filter: 'brightness(1.1) contrast(1.1)'
      }} data-id="element-24" />

        <div className="absolute inset-0 bg-cover bg-center" style={{
        backgroundImage: `url(${beforeImage})`,
        clipPath: `polygon(0 0, ${sliderPosition}% 0, ${sliderPosition}% 100%, 0 100%)`,
        filter: 'sepia(0.3) brightness(0.8)'
      }} data-id="element-25" />

        <div className="absolute top-4 left-4 bg-dark/80 backdrop-blur text-white px-3 py-1 rounded text-sm font-bold uppercase tracking-wider border border-white/10 pointer-events-none" data-id="element-26">
          Before
        </div>
        <div className="absolute top-4 right-4 bg-accent/80 backdrop-blur text-white px-3 py-1 rounded text-sm font-bold uppercase tracking-wider border border-white/10 pointer-events-none" data-id="element-27">
          After
        </div>

        <div className="absolute top-0 bottom-0 w-1 bg-accent-light flex items-center justify-center transform -translate-x-1/2" style={{
        left: `${sliderPosition}%`
      }} data-id="element-28">
          <div className="w-8 h-8 bg-accent-light rounded-full flex items-center justify-center shadow-lg border-2 border-white" data-id="element-29">
            <div className="flex gap-1" data-id="element-30">
              <div className="w-0.5 h-3 bg-dark rounded-full" data-id="element-31" />
              <div className="w-0.5 h-3 bg-dark rounded-full" data-id="element-32" />
            </div>
          </div>
        </div>
      </div>
    </div>;
}